/**
 * @generated SignedSource<<1c074b3955940dae0876a47574d90da4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type ScrapSourceExamGradeEnum = "high_1" | "high_2" | "high_3" | "%future added value";
export type ScrapSourceExamMonthEnum = "month_1" | "month_10" | "month_11" | "month_12" | "month_2" | "month_3" | "month_4" | "month_5" | "month_6" | "month_7" | "month_8" | "month_9" | "none" | "%future added value";
export type ScrapSourceExamYearEnum = "year_2017" | "year_2018" | "year_2019" | "year_2020" | "year_2021" | "year_2022" | "year_2023" | "year_2024" | "year_2025" | "year_2026" | "year_2027" | "year_2028" | "year_2029" | "year_2030" | "%future added value";
export type WorkbookActionEnum = "workbook_delete" | "workbook_publish" | "workbook_tasks_add" | "workbook_tasks_delete" | "workbook_tasks_reorder" | "workbook_update" | "%future added value";
export type WorkbookStatusEnum = "created" | "deactivated" | "publish_required" | "published" | "%future added value";
export type WorkbookFilter = {
  AND?: WorkbookFilter | null;
  DISTINCT?: boolean | null;
  NOT?: WorkbookFilter | null;
  OR?: WorkbookFilter | null;
  createdById_Exact?: string | null;
  createdById_In?: ReadonlyArray<string> | null;
  grade_In?: ReadonlyArray<ScrapSourceExamGradeEnum> | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  modifiedById_Exact?: string | null;
  modifiedById_In?: ReadonlyArray<string> | null;
  month_In?: ReadonlyArray<ScrapSourceExamMonthEnum> | null;
  search?: string | null;
  sequence_Exact?: number | null;
  sequence_In?: ReadonlyArray<number> | null;
  sourceName_In?: ReadonlyArray<string> | null;
  status_In?: ReadonlyArray<WorkbookStatusEnum> | null;
  taskCount_Gte?: number | null;
  taskCount_Lte?: number | null;
  taskUnitAId_In?: ReadonlyArray<string> | null;
  taskUnitBId_In?: ReadonlyArray<string> | null;
  task_In?: ReadonlyArray<string> | null;
  title_Contains?: string | null;
  title_Exact?: string | null;
  title_In?: ReadonlyArray<string> | null;
  year_In?: ReadonlyArray<ScrapSourceExamYearEnum> | null;
};
export type WorkbookOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
  sequence?: Ordering | null;
  title?: Ordering | null;
};
export type WorkbookId_workbookQuery$variables = {
  filters?: WorkbookFilter | null;
  id: string;
  order?: WorkbookOrder | null;
};
export type WorkbookId_workbookQuery$data = {
  readonly workbook: {
    readonly actions: ReadonlyArray<WorkbookActionEnum>;
    readonly grades: ReadonlyArray<{
      readonly grade: string;
      readonly percentile: number | null;
      readonly rawScore: number | null;
      readonly standardScore: number | null;
    }>;
    readonly id: string;
    readonly next: string | null;
    readonly previous: string | null;
    readonly sequence: number;
    readonly tasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
      readonly totalCount: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkbookTaskConnectionDataTable_taskConnection">;
    };
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkbookDescriptionList_workbook" | "WorkbookGradesDataTable_grades" | "WorkbookGradesUpdateDialog_workbook" | "WorkbookTasksAddDialog_workbook" | "WorkbookTasksReorderDialog_workbook" | "WorkbookUpdateDialog_workbook" | "WorkbookWorkbookHistoryPaginator_workbook">;
  };
};
export type WorkbookId_workbookQuery = {
  response: WorkbookId_workbookQuery$data;
  variables: WorkbookId_workbookQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v7 = {
  "alias": null,
  "args": (v6/*: any*/),
  "kind": "ScalarField",
  "name": "previous",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": (v6/*: any*/),
  "kind": "ScalarField",
  "name": "next",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grade",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkbookGradeType",
  "kind": "LinkedField",
  "name": "grades",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardScore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkbookId_workbookQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Workbook",
        "kind": "LinkedField",
        "name": "workbook",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookUpdateDialog_workbook"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookDescriptionList_workbook"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookTasksAddDialog_workbook"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookTasksReorderDialog_workbook"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookGradesDataTable_grades"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookGradesUpdateDialog_workbook"
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskConnection",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkbookTaskConnectionDataTable_taskConnection"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkbookWorkbookHistoryPaginator_workbook"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkbookId_workbookQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Workbook",
        "kind": "LinkedField",
        "name": "workbook",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "modifiedBy",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskConnection",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnitD",
                        "kind": "LinkedField",
                        "name": "unitD",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitATitle",
                            "storageKey": null
                          },
                          {
                            "alias": "unitDTitle",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitBTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitCTitle",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "difficulty",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaskProblem",
                        "kind": "LinkedField",
                        "name": "problem",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "problem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "solution",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "WorkbookHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkbookHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkbookHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "WorkbookWorkbookHistoryPaginator_workbook_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76f93cfeed658fc50a5927a7e8dfc15c",
    "id": null,
    "metadata": {},
    "name": "WorkbookId_workbookQuery",
    "operationKind": "query",
    "text": "query WorkbookId_workbookQuery(\n  $id: ID!\n  $filters: WorkbookFilter\n  $order: WorkbookOrder\n) {\n  workbook(id: $id) {\n    id\n    sequence\n    previous(filters: $filters, order: $order)\n    next(filters: $filters, order: $order)\n    title\n    actions\n    ...WorkbookUpdateDialog_workbook\n    ...WorkbookDescriptionList_workbook\n    ...WorkbookTasksAddDialog_workbook\n    ...WorkbookTasksReorderDialog_workbook\n    ...WorkbookGradesDataTable_grades\n    ...WorkbookGradesUpdateDialog_workbook\n    grades {\n      grade\n      percentile\n      rawScore\n      standardScore\n    }\n    tasks {\n      totalCount\n      edges {\n        node {\n          id\n        }\n      }\n      ...WorkbookTaskConnectionDataTable_taskConnection\n    }\n    ...WorkbookWorkbookHistoryPaginator_workbook\n  }\n}\n\nfragment TaskSequenceItem_task on Task {\n  sequence\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n\nfragment WorkbookDescriptionList_workbook on Workbook {\n  id\n  ...WorkbookStatusLabel_workbook\n  modified\n  modifiedBy {\n    ...UserAvatarText_user\n    id\n  }\n  title\n  tasks {\n    totalCount\n  }\n  year\n  grade\n  month\n  sourceName\n}\n\nfragment WorkbookGradesDataTable_grades on Workbook {\n  grades {\n    grade\n    percentile\n    rawScore\n    standardScore\n  }\n}\n\nfragment WorkbookGradesUpdateDialog_workbook on Workbook {\n  id\n  grades {\n    grade\n    percentile\n    rawScore\n    standardScore\n  }\n}\n\nfragment WorkbookHistoryTimelineItem_workbookHistory on WorkbookHistory {\n  id\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  type\n}\n\nfragment WorkbookStatusLabel_workbook on Workbook {\n  status\n}\n\nfragment WorkbookTaskConnectionDataTable_taskConnection on TaskConnection {\n  edges {\n    node {\n      id\n      sequence\n      unitD {\n        unitATitle\n        unitDTitle: title\n        id\n      }\n      difficulty\n    }\n  }\n}\n\nfragment WorkbookTasksAddDialog_workbook on Workbook {\n  id\n  grade\n  tasks {\n    totalCount\n    edges {\n      node {\n        id\n      }\n    }\n    ...WorkbookTaskConnectionDataTable_taskConnection\n  }\n}\n\nfragment WorkbookTasksReorderDialog_workbook on Workbook {\n  id\n  actions\n  tasks {\n    totalCount\n    edges {\n      node {\n        id\n        sequence\n        difficulty\n        ...TaskSequenceItem_task\n        problem {\n          problem\n          solution\n          id\n        }\n        unitD {\n          id\n          description\n          unitATitle\n          unitBTitle\n          unitCTitle\n        }\n      }\n    }\n  }\n}\n\nfragment WorkbookUpdateDialog_workbook on Workbook {\n  id\n  title\n  grade\n  month\n  year\n  sourceName\n}\n\nfragment WorkbookWorkbookHistoryPaginator_workbook on Workbook {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...WorkbookHistoryTimelineItem_workbookHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "dae8910a31614f92ef3f150672784907";

export default node;
